module.exports = __webpack_public_path__ + "img/jaye-kang-flower-maker.66a525a.jpg";